import { HistoryItem } from './types';
import React from 'react';
import { Box, Flex, Text } from 'rebass';
import FilePreviews from '../File/FilePreviews';
import TimelineItemRail from './TimelineItemRail';
import TimelineStatusComment from './TimelineStatusComment';
import IconLink from '../Icon/IconLink';

export type TimelineItemProps = HistoryItem & {
  noRail?: boolean;
  isInitial?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  isFinal?: boolean;
  children?: React.ReactNode;
  footer?: string;
};

const TimelineItem = (props: TimelineItemProps) => {
  const {
    noRail = false,
    footer,
    children,
    isInitial = false,
    isFirst = false,
    isLast = false,
    type,
    icon,
    iconColor,
    title,
    comment,
    adornment,
    isFinal,
    url,
    thumb,
    contentType,
  } = props;

  return (
    <Flex alignItems="stretch" sx={{ position: 'relative' }}>
      {!noRail && (
        <TimelineItemRail
          isInitial={isInitial}
          isFinal={isFinal}
          isLast={isLast}
          icon={icon}
          iconColor={iconColor}
        />
      )}
      <Box
        flexGrow="1"
        pt={[0, 0, 0, type === 'ATTACHMENT' ? 0 : '3px']}
        pb={isFinal ? 0 : 4}
      >
        {type === 'ATTACHMENT' && url && contentType && (
          <FilePreviews
            files={[
              {
                url,
                contentType,
                thumb: thumb ?? null,
              },
            ]}
          />
        )}

        {title && (
          <>
            {url ? (
              <IconLink
                color="inherit"
                lineHeight="13px"
                fontSize="13px"
                fontWeight="bold"
                icon="link"
                href={url}
                iconAtEnd
                isPrimary
                iconSize={3}
                py="0"
                px="0"
                sx={{
                  textDecoration: 'none',
                }}
              >
                {title}
              </IconLink>
            ) : (
              <Text
                fontFamily="root"
                lineHeight="13px"
                fontSize="13px"
                fontWeight="bold"
              >
                {title}
              </Text>
            )}
          </>
        )}

        {comment && (
          <TimelineStatusComment
            mt={title ? 1 : undefined}
            mb={footer ? 1 : undefined}
            comment={comment}
          />
        )}

        {children}

        {/* Meta */}
        {footer && (
          <Flex alignItems="center" sx={{ gap: 1 }}>
            <Text variant="bodyTimelineItalic">{footer}</Text>
            {adornment}
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default TimelineItem;
